import React from 'react';
import PropTypes from 'prop-types';
import Card from 'components_v2/common/CardV2/Card';
import s from './ThreeCard.scss';

class ThreeCard extends React.Component {
  render() {
    const {
      data,
      gridRequired,
      // oneByOneCard = { items: [] },
      // subSection,
      // wrapperClass,
    } = this.props;
    const items = data?.items || this.state.data?.items;
    const itemsList = items || [];

    if (!data?.items || !data.items?.length) {
      return null;
    }
    return (
      <div className={s.threeCard}>
        <div className="row">
          {itemsList instanceof Array &&
            itemsList.map((col, index) => (
              <React.Fragment key={col.id || col.name}>
                {!(col.data && col.data instanceof Array) && (
                  <div
                    className={gridRequired ? s.cards_count_9 : 'col_l_4'}
                    key={index}
                  >
                    <Card
                      data={col}
                      showDescription
                      isVerticalTile
                      timeStampHtml
                      imgWidth="312"
                      istoipListing
                      isVertical
                      isHomeListing
                      gaPageName="TOIPlus_HomePage"
                      tpPageName="toiphome"
                      userData={this.props.userData}
                    />
                  </div>
                )}
              </React.Fragment>
            ))}
        </div>
      </div>
    );
  }
}
ThreeCard.propTypes = {
  data: PropTypes.shape({}).isRequired,
  userData: PropTypes.shape({}),
};

ThreeCard.defaultProps = {
  userData: undefined,
};

export default ThreeCard;
